import useViewTracker from "./useViewTracker";

export const ViewTrackerInitializer = () => {
	useViewTracker();

	return null;
};
